import { ReportsTemplatesRoutes } from './../../models/reports-templates.enum';
import { ActivatedRoute } from '@angular/router';
import { DataService } from './../../dataService';
import { IReportsDataServiceLeftMenuExpantionModel, ReportsDataServiceModelValues } from './../../models/reports-data-service-model';
import { Subscription } from 'rxjs';
import { IReportsFilterModel } from './../../models/reports-filter.models';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-reports-templates',
    templateUrl: './reports-templates.component.html',
    styleUrls: ['./reports-templates.component.scss']
})
export class ReportsTemplatesComponent implements OnInit {

    subscription: Subscription = new Subscription();

    //#region Properties
    public selectedWindow: string = '';
    public reportName: string = '';
    public dateFrom: any;
    public dateTo: any;
    public dateFilterLabel: string = "All Time";
    public reportDate: any;
    public selectedRepFilter = { name: "All", userName: "All", id: 0 };
    public selectedDateQuestionChannelfilter = { name: "All", id: 0 };
    public selectedDateModuleFilter = { name: 'All', id: 0 };
    public selectedDateCategoryFilter = { name: 'All', id: 0 };
    public selectedDateAccountNameFilter = { businessName: "All", id: 0 };

    public pageSize = 15;
    public pageNumber = 0;
    public Months: any[] = [];
    public cols: any;
    public filterByInputValue: any = [];
    public selectedFilterGroup: IReportsFilterModel[] = [];
    public reportsData = [];
    public totalRecords: number;
    public totalPages: number;
    public results = [];
    public IsShowReportTemplate: boolean = true;
    public noContactFindOrLoadingText = 'Loading....';
    public OrganizationName = "";

    public dropdownAnsReports: any = [];
    public allQuestionnaireChannels: any[] = [];
    public selectedQuestionnaireChannel: any = null;
    public questionnaireChartData: any = null;

    filterDataByTime:any = [];
    selectedDateFilter: any = null;
    changeDateEnable = false;

    constructor(
        private router: ActivatedRoute,
        private dataService: DataService
    ) { }

    ngOnInit(): void {
        this.subscription = this.router.paramMap.subscribe((param: any) => {
            const activityType = param.params.type;
            this.selectedWindow = "";
            this.selectedFilterGroup = [];
            this.filterDataByTime = [];
            this.selectedDateFilter = null;
            this.changeDateEnable = false;
            switch (activityType) {
                case ReportsTemplatesRoutes.template1:
                    this.selectedWindow = "template1";
                    break;
                case  ReportsTemplatesRoutes.template2:
                    this.selectedWindow = "template2";
                    break;
                case ReportsTemplatesRoutes.template3:
                    this.selectedWindow = "template3";
                    break;
                case  ReportsTemplatesRoutes.template4:
                    this.selectedWindow = "template4";
                    break;
                case ReportsTemplatesRoutes.template5:
                    this.selectedWindow = "template5";
                    break;
                case  ReportsTemplatesRoutes.template6:
                    this.selectedWindow = "template6";
                    break;
                case ReportsTemplatesRoutes.template7:
                    this.selectedWindow = "template7";
                    break;
                default:
                    break;
            }

            this.dataService.sendData<IReportsDataServiceLeftMenuExpantionModel>({ actionType: ReportsDataServiceModelValues.reportsLeftMenuExpansion, value: this.selectedWindow });
        });
    }

    onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.onApplyFilter(selectedWindow, selectedFilters);
    }

    onClosePanel(selectedWindow: string): void {
    }

    onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
    }

    onChangeRange(selectedWindow: string, event: any): void {

    }
}
